import React, { Component } from "react";
import ContactForm from "./ContactForm";
import Header from "../HeaderSection/Header";
import Breadcrumb from "../Blogs/Breadcrumb";
import FooterSection from "../FooterSection/Footer";
import axios from "axios";
import ContactSection from "./Contact";
import Navbar from "../Navbar/Navbar";
import logo from "../../assets/logo.png";
const BASE_URL =
  "https://my-json-server.typicode.com/themeland/json-server-1/themeOneContactSection";

class ContactPage extends Component {
  state = {
    data: {},
    iconList: [],
  };
//   componentDidMount() {
//     axios
//       .get(`${BASE_URL}`)
//       .then((res) => {
//         this.setState({
//           data: res.data,
//           iconList: res.data.iconList,
//         });
//         // console.log(this.state.data)
//       })
//       .catch((err) => console.log(err));
//   }
  render() {
    return (
      <div className="contact-page">
        {/*====== Scroll To Top Area Start ======*/}
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        {/*====== Scroll To Top Area End ======*/}
        <div className="main">
          {/* <Header imageData={"/img/logo-white.png"} /> */}
           <Navbar imageData={logo} />
          {/* <Breadcrumb title="Contact Us" /> */}
          <ContactSection />
          {/*====== Map Area End ======*/}
          <FooterSection />
        </div>
      </div>
    );
  }
}

export default ContactPage;
